/* eslint-disable no-unused-vars */
import React, {
  useEffect,
  useState,
  useRef,
  useReducer,
  useMemo,
  useLayoutEffect,
  useCallback,
  Component,
  useContext
} from "react";
import ReactDOM from "react-dom";
import querystring from "query-string";
import "./PipelineStatusBoardChooser.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faTimes } from "@fortawesome/pro-regular-svg-icons";
import classnames from "classnames";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { faGripVertical } from "@fortawesome/pro-solid-svg-icons";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";

import { PipelineStatusChooserListnerDict } from "./PipelineStatusBoardChooserHelper";
import { subscribeUniqueEvent } from "../../Helpers/ComponentsHelper";
import Button from "../Button/Button";
import Input from "../Input/Input";
import Checkbox from "../Checkbox/Checkbox";
import { useLocation } from "react-router-dom";
import { ServerAwareUpdateTempViewsContext, ServerAwareUpdateViewsContext, ServerAwareViewsContext } from "../CGrid/ServerAwareViews";
import { FormattedMessage, useIntl } from "react-intl";
import { useSpace } from "../../Contexts/SpaceContext";
import { AppFavoriteContext } from "../../Containers/AppBar/AppFavoriteProvider";
import { ServerAwareFavoritesContext } from "../../Containers/AppBar/ServerAwareFavorite";
import { AppBarFavoriteTreeSetter } from "../../Containers/AppBar/AppBarFavoriteQuery";
import { useFavoriteOrViewChecker } from "../../Containers/AppBar/AppBarHelper";

const getState = (columns, schemaName, pipelineId, unresolvedOrderList) => {
  //local storage
  // let gridColumnLayout = JSON.parse(
  //   window.localStorage.getItem("ar-grid-pipelineStatus-layout")
  // );

  const orderList = unresolvedOrderList || [];

  const orderListDict = {};

  let orderListExists = Array.isArray(orderList) && orderList.length > 0 ? true : false;
  if (orderListExists)
    for (const ol of orderList) {
      orderListDict[ol] = true;
    }

  const state = {};

  for (const c of columns) {
    if (!orderListExists) state[c.Id] = true;
    else state[c.Id] = orderListDict[c.Id] || undefined;
  }
  //   console.log(state);
  return state;
};

const getOrderedColumns = (
  Columns,
  schemaName,
  pipelineId,
  unresolvedOrderList
) => {
  const orderList = unresolvedOrderList || [];
		
  let orderListExists = Array.isArray(orderList) ? true : false;
  if (orderListExists && orderList) {
    return orderList.map((e) => {
      return e;
    });
  } else {
    return Columns.map((e) => {
      return e.Id;
    });
  }
};

const getfieldTitleDict = (Columns) => {
  const result = {};
  for (const c of Columns) {
    result[c.Id] = c;
  }
  return result;
};

export const PipelineStatusChooserViews = ({ ...rest }) => {
  const { schema, schemaView, name, onClose } = rest;
  const location = useLocation();
  const { search } = location;
  const queryObj = querystring.parse(search);
  const { viewPref } = queryObj;
  const schemaViews = useContext(ServerAwareViewsContext);
  const lsIndex = schemaViews?.findIndex((e) => e.id === viewPref);
  const lsViews =
    schemaViews && lsIndex === -1
      ? schemaViews[0]
      : schemaViews
      ? schemaViews[lsIndex]
      : {};
  const schemaName = schemaView
    ? schemaView.name
    : schema
    ? schema.name
    : rest.Name;
    const updateLsViews = useContext(ServerAwareUpdateTempViewsContext);
  const space = useSpace();

  const handleChange = (state) => {
    let gridSavedViews = JSON.parse(
      window.localStorage.getItem(`ar-grid-saved-views-space-${space.Id}`)
    );
    const viewGridViews = gridSavedViews[schemaName];
    const index = viewGridViews.findIndex((e) => e.id === viewPref);
    let resolvedIndex = index === -1 ? 0 : index;
    let viewGridObject = viewGridViews[resolvedIndex] || {};
    

    viewGridObject.pipelineStatus = [...state];
    viewGridViews[resolvedIndex] = viewGridObject;
    gridSavedViews[schemaName] = viewGridViews;
    localStorage.setItem(
      `ar-grid-saved-views-space-${space.Id}`,
      JSON.stringify(gridSavedViews)
    );
    updateLsViews && updateLsViews();

    onClose();
  };

  const handleReset = () => {
    let gridSavedViews = JSON.parse(
      window.localStorage.getItem(`ar-grid-saved-views-space-${space.Id}`)
    );
    const viewGridViews = gridSavedViews[schemaName];
    const index = viewGridViews.findIndex((e) => e.id === viewPref);
    let resolvedIndex = index === -1 ? 0 : index;
    let viewGridObject = viewGridViews[resolvedIndex] || {};
    viewGridObject.pipelineStatus = undefined;
    viewGridViews[resolvedIndex] = viewGridObject;
    gridSavedViews[schemaName] = viewGridViews;
    localStorage.setItem(
      `ar-grid-saved-views-space-${space.Id}`,
      JSON.stringify(gridSavedViews)
    );
    updateLsViews && updateLsViews();
    onClose();
  };

  return (
    <PipelineStatusChooserComp
      {...rest}
      handleChange={handleChange}
      pipelineStatus={lsViews.pipelineStatus}
      handleReset={handleReset}
    />
  );
};


export const useFavoritePipelineStatus = (onClose) => {
  const FavoriteItem = useContext(ServerAwareFavoritesContext);
  const { pipelineStatus } = FavoriteItem.data;
  const setTree = useContext(AppBarFavoriteTreeSetter);
  const handleColumnChange = useCallback(
    (result) => {
      setTree((oldTree) => {
        const newTree = { ...oldTree };
        const { rootId, items } = newTree;
        const newItems = { ...items };
        const newItem = { ...newItems[FavoriteItem.id] };
        const newData = { ...newItem.data };
        newData.pipelineStatus = [...result];
        newItem.data = newData;
        newItems[FavoriteItem.id] = newItem;
        return {
          rootId,
          items: newItems
        };
      });
      onClose();
    },
    [FavoriteItem.id, onClose, setTree]
  );

  const handleColumnReset = useCallback(
    (result) => {
      setTree((oldTree) => {
        const newTree = { ...oldTree };
        const { rootId, items } = newTree;
        const newItems = { ...items };
        const newItem = { ...newItems[FavoriteItem.id] };
        const newData = { ...newItem.data };

        newData.pipelineStatus = undefined;
        newItem.data = newData;
        newItems[FavoriteItem.id] = newItem;
        return {
          rootId,
          items: newItems
        };
      });
      onClose();
    },
    [FavoriteItem.id, onClose, setTree]
  );

  return {
    handleColumnChange,
    handleColumnReset,
    pipelineStatus,
  };
};

export const PipelineStatusChooserFavorites = ({ ...rest }) => {
  const { onClose } = rest;
  const { handleColumnChange, handleColumnReset, pipelineStatus } =
	useFavoritePipelineStatus(onClose);

  return (
    <PipelineStatusChooserComp
      {...rest}
      handleChange={handleColumnChange}
      pipelineStatus={pipelineStatus}
      handleReset={handleColumnReset}
    />
  );
};

export const PipelineStatusChooser = ({ ...rest }) => {
	const result = useFavoriteOrViewChecker()

  if (result) return <PipelineStatusChooserFavorites {...rest} />;
  return <PipelineStatusChooserViews {...rest} />;
};

export const PipelineStatusChooserComp = ({
  schema,
  onClose,
  setIsOpen,
  isOpen,
  schemaView,
  Columns,
  pipelineId,
	pipelineStatus,
  handleChange,
  handleReset,
  ...rest
}) => {

  const fieldDict = getfieldTitleDict(Columns);

  useEffect(() => {
    return subscribeUniqueEvent((e) => {
      if (e.keyCode === 27) {
        e.preventDefault();
        setIsOpen(false);
      }
    });
  }, [isOpen, setIsOpen]);

  const space = useSpace()
  const schemaName = schemaView ? schemaView.name : schema ? schema.name : rest.Name;
  const [searchBarValue, setSearchBarValue] = useState("");
  const [selectionState, setSelectionState] = useState(() => {
    return getState(Columns, schemaName, pipelineId, pipelineStatus);
  });

  const resolvedColumns = useMemo(() => {
    if (!searchBarValue) return Columns;

    const newColumns = Columns.filter(
      (v) =>
        v.title && v.title.toLowerCase().includes(searchBarValue.toLowerCase())
    );

    return newColumns;
  }, [Columns, searchBarValue]);

  const handleSelectionChange = useCallback((field, isChecked) => {
    setSelectionState((s) => {
      const newState = { ...s };
      newState[field] = isChecked;
      return newState;
    });
  }, []);
	// const updateLsViews = useContext(ServerAwareUpdateViewsContext);
  const submit = () => {
		const result = [];
		for (const key in selectionState) {
			if (Object.hasOwnProperty.call(selectionState, key)) {
				const element = selectionState[key];
				if(element)result.push(key)
			}
		}
		handleChange(result);
  };

  const reset = () => {
    handleReset()
  };

  return (
    <div className="CardChooser-ModalWrap">
      <div className="p-30">
        <div className="fs-16 mb-10 fw-bold text-black d-flex justify-content-between">
          <span className="pt-1"><FormattedMessage id={"CHOOSE_PIPELINE_STATUS"} /></span>
        </div>
        <div className="d-flex mb-4">
          <div className="CardChooserContent justify-content-between pr-4 CardChooserContent-borderRight">
            <ColumnChooserSearchBar
              value={searchBarValue}
              handleChange={setSearchBarValue}
              className="w-a mb-3"
            />

            <ColumnChooserCheckList
              filterBy={searchBarValue}
              onChange={handleSelectionChange}
              Columns={resolvedColumns}
              selectionState={selectionState}
            />
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <div>
            <Button onClick={reset} vType="link-primary">
						<FormattedMessage id={"RESTORE_PIPELINE_STATUS"} />
            </Button>
          </div>
          <div>
            <Button
              className="mr-3"
              onClick={() => {
                setIsOpen(false);
              }}
              vType="link-danger"
            >
               <FormattedMessage id={"CANCEL"} />
            </Button>
            <Button onClick={submit} vType="primary">
						<FormattedMessage id={"SAVE"} />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

const ColumnChooserSearchBar = ({
  handleChange,
  className,
  value,
  focused,
  ...rest
}) => {
	const intl = useIntl()
  const { inputRef, handleFocus, handleBlur } = rest;
  const placeholder = intl.formatMessage({id: "SEARCH_PIPELINE_STATUS"});

  const onChange = (e) => {
    handleChange(e.target.value);
  };

  return (
    <div
      className={classnames(
        "ssi-control rounded Card-chooser-search-bar text-black ar-server-aware-input d-flex align-items-center p-2 mb-2",
        className,
        {
          selected: focused
        }
      )}
    >
      <div className="ar-server-aware-input-icon mr-2">
        {/* {isLoading ? (
          <LoaderSpinner className="text-primary" />
        ) : (
          <FontAwesomeIcon icon={faSearch} className="text-primary" />
        )} */}
        <FontAwesomeIcon icon={faSearch} className="text-primary" />
      </div>
      <Input
        ref={inputRef}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        onFocus={handleFocus}
        onBlur={() => {
          if (handleBlur) handleBlur();
        }}
        className="flat-input p-0"
        {...rest}
      />
      {value.length > 0 && (
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            handleChange("");
          }}
        >
          {" "}
          <FontAwesomeIcon icon={faTimes} className="text-warning" />
        </div>
      )}
    </div>
  );
};

const ColumnChooserCheckList = ({ Columns, selectionState, onChange }) => {
  let columnsList = "";
  let filteredList = null;

  if (Columns) {
    columnsList = Columns.map((e, index) => {
      const isChecked = selectionState[e.Id] || false;
      return (
        <div
          key={e.Id + "" + index + "" + e.Id}
          className="d-flex justify-content-start mb-2 text-black"
        >
          <Checkbox
            disabled={e.required && isChecked}
            change={() => {
              onChange(e.Id, !isChecked);
            }}
            checked={isChecked}
            textValue={e.title.toUpperCase()}
          />
          {/* <span
            style={{ paddingTop: 2 }}
            onClick={() => {
              !e.required && onChange(e.Id, !isChecked);
            }}
            className={`disableLabelSelect text-black fs-14 ml-2 ${
              e.required ? "Checkbox-box-disabled" : ""
            }`}
          >
            {e.title.toUpperCase()}
          </span> */}
        </div>
      );
    });
  }

  return (
    <div className="CardChooserCheckList">
      <div
        style={{ background: "#ffffff" }}
        className="fs-14 mb-3 sticky-top fw-medium text-black"
      >
       <FormattedMessage id="NAME_OF_PIPELINE_STATUS"/>
      </div>
      <div className="ml-2">{columnsList}</div>
    </div>
  );
};
